import Modal from "react-modal";
import "../../../styles/Modals.css";

// The admin's free-text rules (`rules_text`, "@@"-delimited sections - same
// convention diet_plans.steps already uses) are appended after a fixed,
// always-present explanation of the mechanics, so every challenge is
// understandable even before the admin writes anything custom.
function ChallengeRules({ show, onClose, challenge }) {
  if (!challenge) return null;
  const extraSections = (challenge.rules_text || "")
    .split("@@")
    .map((s) => s.trim())
    .filter(Boolean);

  return (
    <Modal isOpen={show} onRequestClose={onClose} className="modal" overlayClassName="overlay">
      <div className="modal-header">
        <h2>قوانین چالش</h2>
        <a onClick={onClose}>
          <span className="icon-iconclose rectangle-1 heading-1 grey-3"></span>
        </a>
      </div>
      <div className="modal-body rightAlign max-height300">
        <p className="yekan grey-1 marginBottom1r">
          ⏱ این چالش {challenge.duration_days} روزه‌ست.
        </p>
        <p className="yekan grey-1 marginBottom1r">
          🍽 با شروع چالش، غذاهاش بر اساس تاریخی که انتخاب می‌کنی خودکار به تقویمت اضافه
          میشن.
        </p>
        <p className="yekan grey-1 marginBottom1r">
          ✅ هر روز فقط همون روز رو می‌تونی تیک بزنی؛ روز بعد از نیمه‌شب فعال میشه.
        </p>
        <p className="yekan grey-1 marginBottom1r">
          🏁 شروع چالش {challenge.start_points} امتیاز و هر تیک روزانه {challenge.daily_points}{" "}
          امتیاز داره.
        </p>
        {challenge.missed_day_penalty > 0 && (
          <p className="yekan grey-1 marginBottom1r">
            ⚠️ اگه یه روز رو از دست بدی، امتیاز روز بعدی که تیک بزنی کمتر میشه.
          </p>
        )}
        <p className="yekan grey-1 marginBottom1r">
          🏆 لیدربورد بر اساس مجموع امتیازها خودکار به‌روز میشه.
        </p>
        <p className="yekan grey-1 marginBottom1r">
          🎉 وقتی همه روزهای چالش رو تیک بزنی، چالش کامل میشه.
        </p>
        <p className="yekan grey-1 marginBottom1r">
          📅 حذف یه غذا از تقویم، شرکتت توی چالش رو لغو نمی‌کنه؛ فقط خودت باید یادت باشه
          پختیش یا نه.
        </p>

        {extraSections.length > 0 && (
          <>
            <p className="subject-1 grey-1 marginTop5" style={{ fontWeight: "bold" }}>
              نکات تکمیلی
            </p>
            {extraSections.map((section, i) => (
              <p key={i} className="caption-1 yekan grey-2 marginBottom1r">
                {section}
              </p>
            ))}
          </>
        )}
      </div>
    </Modal>
  );
}

export default ChallengeRules;
